import React from 'react';
import { Helmet } from 'react-helmet-async';
import { landingPages } from '@/content/pages';
import { renderHub } from '@/lib/landingFormat';

const Locations = () => (
  <div className="min-h-screen pt-16 bg-gradient-to-b from-white to-slate-100 dark:from-slate-900 dark:to-slate-950">
    <Helmet>
      <title>Locations: Web Design, Google Ads & AI Automation | Omnicraft</title>
      <meta name="description" content="City pages for Omnicraft's Google Ads management, AI workflow automation and web design services for small businesses across the United States." />
    </Helmet>
    <div
      className="container-custom py-12 max-w-3xl mx-auto prose prose-lg prose-slate dark:prose-invert prose-a:text-primary"
      dangerouslySetInnerHTML={{ __html: renderHub('locations', landingPages) }}
    />
  </div>
);

export default Locations;
